import { GzTooltipWebComponent } from './component/GzTooltipWebComponent';
import { GzTooltipBoxWebComponent } from './component/GzTooltipBoxWebComponent';
import { GzTooltip } from './component/GzTooltip';
import { WEB_COMPONENT_GZ_TOOLTIP, WEB_COMPONENT_GZ_TOOLTIP_BOX } from '../../webcomponents.constants';

export { GzTooltip, GzTooltipWebComponent, GzTooltipBoxWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_TOOLTIP, GzTooltipWebComponent);
window.customElements.define(WEB_COMPONENT_GZ_TOOLTIP_BOX, GzTooltipBoxWebComponent);
